import { useTranslation } from "react-i18next";
import { useModal } from "context/ModalContext";
import { getButtonsNoYes } from "context/helpers/helperModalContext";
import { useRef } from "react";
import { NumericFormat } from "react-number-format";
import { Formik } from "formik";
import { Form } from "react-bootstrap";
import { useSettings } from "context/SettingsContext";
import InputPriceRate from "components/others/InputPriceRate";
import { getBaseCurrencyPrefix, getBaseCurrencySymbol } from "utils/helpers/currency/currencyHelpers";

const useChangePriceSale = () => {

    const { t } = useTranslation(['Objects', 'Rate', 'Warehouses']);
    const { showDlg } = useModal();
    const { localSettings } = useSettings();
    const refForm = useRef();
    const refInputPriceSale = useRef();
    const paramsDelDlg = {
        buttons : [...getButtonsNoYes(t)],  
        type    : 'confirm',
    } 


    const changePriceSale = ({price, priceSale}, cbFunct) => {

 
        const p = {
            ...paramsDelDlg,
            title : t('changePriceSale.title'),
            text: (<>
                <Formik initialValues={{
                    priceSale, price
                }}
                onSubmit={(values, {setSubmitting}) => {
                    showDlg(false);
                    cbFunct(values);
                }}>

                {({handleSubmit, isSubmitting, setFieldValue, values}) => ( 
                <form ref={refForm}
                    onSubmit={handleSubmit} style={{marginTop:'-20px'}}>

                    <Form.Group className="mb-3"> 
                        <label className="form-label text-muted w-100 d-flex justify-content-between">
                            {t('Warehouses:labelPrice')} {getBaseCurrencySymbol()}:

                        </label>
                        <NumericFormat   
                            id="inputPriceSale"
                            className="form-control object-price"
                            allowNegative={false}
                            prefix={getBaseCurrencyPrefix()}   
                            thousandSeparator=" "
                            decimalSeparator="."
                            allowedDecimalSeparators={['.', ',']}
                            decimalScale={2}
                            allowLeadingZeros={true}
                            value={values.price}
                            required={true}
                            onValueChange={(val)=>{
                                setFieldValue('price', val.value)
                            }}/>
                    </Form.Group>


                    <Form.Group>
                    <label className="form-label text-muted">{t('Warehouses:labelPriceSale')} {getBaseCurrencySymbol()}:</label>
                        <NumericFormat   
                            className="form-control object-price"
                            prefix={getBaseCurrencyPrefix()}   
                            thousandSeparator=" "
                            decimalSeparator="."
                            allowedDecimalSeparators={['.', ',']}
                            decimalScale={2}
                            allowLeadingZeros={true}
                            value={values.priceSale}
                            required={true}
                            onValueChange={(val)=>{setFieldValue('priceSale', val.value)}}/>
                            
                            <input type="submit" className="d-none"/>
                    </Form.Group>
                </form>
                )}
                </Formik>
            </>),
            idFirstFocus:'inputPriceSale'
        }
        p.buttons[1].handleClick = (e) => {  
                e.preventDefault();
                if (refForm.current?.reportValidity()) {
                    refForm.current?.requestSubmit?.();  
                }
        }
        showDlg(p)
    }
 

    return {
        changePriceSale
    }
}

export default useChangePriceSale;